export type QbSyncFields = {
  qb_sync_status?: string | null;
  qb_synced_at?: string | null;
  qb_sync_error?: string | null;
  qb_customer_id?: string | null;
  qb_invoice_id?: string | null;
};

export const qbSyncBadgeClass = (status?: string | null) => {
  if (status === 'synced') return 'bg-green-50 text-green-800';
  if (status === 'failed') return 'bg-red-50 text-red-800';
  if (status === 'pending') return 'bg-amber-50 text-amber-800';
  return 'bg-gray-100 text-gray-700';
};

export const qbSyncLabel = (fields: QbSyncFields, entity: 'company' | 'invoice' = 'invoice') => {
  const id = entity === 'company' ? fields.qb_customer_id : fields.qb_invoice_id;
  if (fields.qb_sync_status === 'synced') {
    return `Synced${id ? ` (${id})` : ''}${
      fields.qb_synced_at ? ` · ${new Date(fields.qb_synced_at).toLocaleDateString()}` : ''
    }`;
  }
  if (fields.qb_sync_status === 'failed') {
    return `Sync failed${fields.qb_sync_error ? `: ${fields.qb_sync_error}` : ''}`;
  }
  if (fields.qb_sync_status === 'pending') return 'Sync pending';
  return 'Not synced';
};
